<app-pi-indicador-flujo></app-pi-indicador-flujo>
<div class="invalidez-layout">
  
  <!-- Aquí cargarán dinámicamente InvalidezHomeComponent y las futuras 7 páginas -->
  <main class="invalidez-content">
    <router-outlet></router-outlet>
  </main>

  <!-- El footer transversal -->
  <app-pi-help-footer></app-pi-help-footer>

</div>